export const searchReviews = /* GraphQL */ `
  query SearchReviews(
    $filter: SearchableReviewFilterInput
    $sort: SearchableReviewSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchReviews(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        brand_id
        product_ids
        buyer_id
        order_id
        rate
        title
        comment
        remove_flag
        createdAt
        updatedAt
        brand {
          id
          brand_owner
          brand_name
          brand_yomigana
          brand_type
          brand_content
          brand_imageKey
          brand_icon_imageKey
          brand_logo_imageKey
          brand_publication
          brand_retail_stores_number
          brand_category
          brand_target_age
          brand_target_gender
          brand_website_url
          brand_work_with_big_box
          brand_address
          brand_instagram_account
          brand_facebook_account
          brand_rating
          brand_annual_turnover
          brand_public_status
          brand_howtoknowhomula
          brand_audit_status
          createdAt
          updatedAt
          owner
          designed_in
          established
          tagIds
          tags
          brand_collections
          movie_url
          brand_modal_imageKeys
          stockists {
            stockist
            address
          }
          featured_in
          exclude_zip_code
          is_sale_brand
          hubspot_company_id
          return_to_brand
          terms_of_sample
          auto_message_enabled
          auto_message
          account {
            id
            email
            first_name
            last_name
            web_site_URL
            instagram_account
            zip_code
            location
            tel
            company_name
            term_approval_status
            createdAt
            updatedAt
            owner
          }
          product {
            nextToken
          }
          collections {
            nextToken
          }
          contacts {
            nextToken
          }
        }
        replies {
          items {
            id
            review_id
            brand_id
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const searchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        imageKeys {
          items {
            imageKey
          }
        }
        brand {
          brand_name
        }
      }
      nextToken
      total
    }
  }
`;
